<template>
  <div
    class="aside"
  >
    <div
      class="aside-header"
    >
      <label
        class="btn-mid u-margin-right-XS btn_white"
        for="settings"
      >
        <input
          type="radio"
          id="settings"
          value="settings"
          v-model="selected_tab"
          checked
          class="u-hide"
        />
        <span class="btn_slider btn_underline u-text-align-center">
          <i class="icon-contro "></i>
          設定
        </span>
      </label>
      <label
        class="btn btn-mid btn_white"
        for="about"
      >
        <input
          type="radio"
          id="about"
          value="about"
          v-model="selected_tab"
          class="u-hide"
        />
        <span class="btn_slider u-text-align-center btn_underline">
          <i class="icon-TT_logo-icon "></i>
          關於
        </span>
      </label>
    </div>
    <hr class="u-hr-gray">

    <div
      v-if="selected_tab == 'settings'"
      class="aside-options"
    >
      <div
        class=""
      >
        <span class="u-margin-right-XS mobile_hide">
          <i class="icon-date"></i>
          初始時間
        </span>
        <label class="select_arrow">
          <select
            v-model="selected_init_time_z"
          >
            <option
                v-for="(init_time_z, index) in init_time_z_list"
                :key="index"
                :value="init_time_z"
              >
              {{ init_time_lst_str(init_time_z) }}
            </option>
          </select>
        </label>
      </div>
      <hr class="u-hr-gray">
      <div class="aside_map_section">
        <div
          class="aside_map-box"
        >
          <template v-for="(_base_layer, index) in base_layers">
              <label
                :class="[_base_layer.background_img, 'btn', 'btn-small']"
                :for="'baselayer-selector' + index"
                :key="'baselayer-label' + index"
              >
                <input
                  type="radio"
                  :key="'baselayer-selector' + index"
                  :value="_base_layer.layer"
                  :id="'baselayer-selector'+ index"
                  name="baselayer-selector"
                  :checked="_base_layer.layer === selected_map_options['base_layer']"
                  @change="set_selected_map_option('base_layer', _base_layer.layer)"
                  class="u-hide"
                >
                <span class="btn_slider btn_underline u-text-align-center u-font-white">
                  <i :class="_base_layer.icon" class=""></i>
                  {{ _base_layer.name }}
                </span>
              </label>
          </template>
        </div>
      </div>
      <hr class="u-hr-gray">
      <template v-for="(_option, index) in layer_options">
        <div
          :key="'div_option'+index"
        >
          <label
            class="btn btn-long btn_white"
            :for="'option-checkbox' + index"
            :key="'option-checkbox-label' + index"
          >
            <input
              type="checkbox"
              :key="'option-checkbox' + index"
              :id="'option-checkbox'+ index"
              :checked="selected_options[_option.option_name]"
              @change="set_selected_option(_option.option_name, $event.target.checked)"
              class="u-hide"
            >
            <span class="btn_slider u-text-align-left btn_underline">
              <i :class="_option.icon" class=" u-margin-right-XS"></i>
              {{ _option.name }}
              <span
                v-show='_option.option_name == "show_satellite"'
                class="u-text-align-left btn_underline"
              >
                {{ satellite_latest_time }}
            </span>
            </span>
          </label>
          <img
            v-if="_option.option_name==='show_typhoon_probability'"
            class="color_bar"
            src="@/assets/imgs/ty_prob_colorbar.png"
            style="width: 100%"
          >
        </div>
      </template>

        <div
          :key="'div_option_wind'"
          class="div_option_wind"
        >
          <label
            :for="'option-checkbox-wind'"
            :key="'option-checkbox-label-wind'"
            class="btn btn btn-long btn_white"
          >
            <input
              type="checkbox"
              :key="'option-checkbox-wind'"
              :id="'option-checkbox-wind'"
              :checked="selected_options[wind_layer_options.option_name]"
              @change="set_selected_option(wind_layer_options.option_name, $event.target.checked)"
              class="u-hide"
            >
            <span class="btn_slider u-text-align-left btn_underline">
              <i :class="wind_layer_options.icon"></i>
              {{ wind_layer_options.name }}
            </span>
          </label>
          <div
            v-if="selected_options[wind_layer_options.option_name]"
            class="wind_box"
          >
            <template v-for="(_src, index) in wind_layer_options.sources">
              <div
                :key="'div_option_wind'+index"
              >
                <label
                  :for="'option-checkbox-wind' + index"
                  :key="'option-checkbox-label-wind' + index"
                  class="btn btn btn-long btn_wind btn_black"
                >
                <input
                  type="radio"
                  :key="'option-checkbox-wind' + index"
                  :id="'option-checkbox-wind'+ index"
                  :checked="_src.id === selected_wind_src"
                  @change="set_selected_wind(_src.id)"
                  class="u-hide"
                >
                <span class="btn_slider u-text-align-left btn_underline">
                  <i
                    :class="[_src.icon, 'u-font-red']"
                    v-if="_src.id === selected_wind_src"></i>
                  <span class="wind_type_text">
                    {{ _src.name }}
                    <span v-if="selected_wind_src == _src.id" class="wind_src_dtg">{{ selected_wind_info }}</span>
                  </span>
                </span>
                </label>
              </div>
            </template>
          </div>
        </div>

    </div>

    <div
      v-if="selected_tab == 'about'"
      class="aside-options"
    >
      <About/>
    </div>
  </div>
</template>

<script>
import About from '@/components/typhoon_tw/About'
import * as types from '@/store/types'
import {mapGetters, mapActions} from 'vuex'

export default {
  components: {
    About: About
  },
  data () {
    return {
      base_layers: [{
        name: '簡易',
        layer: 'simple',
        icon: 'icon-simple-map',
        background_img: 'btn_simple_map_background'
      }, {
        name: '地形',
        layer: 'terrain',
        icon: 'icon-terrain',
        background_img: 'btn_terrain_map_background'
      }, {
        name: '衛星',
        layer: 'satellite',
        icon: 'icon-satellite',
        background_img: 'btn_satellite_map_background'
      }],
      layer_options: [{
        name: '時間標籤',
        option_name: 'show_timelabel',
        icon: 'icon-clock'
      }, {
        name: '經緯度線',
        option_name: 'show_graticule',
        icon: 'icon-latitudelongitude'
      }, {
        name: '各單位名稱',
        option_name: 'show_src_name',
        icon: 'icon-country'
      }, {
        name: '暴風圈與位置',
        option_name: 'show_spotlight',
        icon: 'icon-TY_site-point'
      }, {
        name: '放假機率',
        option_name: 'show_typhoon_probability',
        icon: 'icon-country'
      }, {
        name: '各縣市放假機率時間軸',
        option_name: 'show_probability_chart',
        icon: 'icon-country'
      }, {
        name: '衛星雲圖',
        option_name: 'show_satellite',
        icon: 'icon-satellite'
      }],
      wind_layer_options: {
        name: '風場圖',
        option_name: 'show_wind',
        icon: 'icon-wind',
        sources: [
          {
            name: 'NCEP GFS',
            id: 'ncep',
            icon: 'icon-N_TY'
          },
          {
            name: 'Google WeatherNext',
            id: 'weathernext',
            icon: 'icon-wind'
          }
        ]
      },
      selected_tab: 'settings'

    }

  },

  methods: {
    ...mapGetters({
      get_init_time_z_list: types.GET_INIT_TIME_Z_LIST,
      get_options: types.GET_OPTIONS,
      get_map_options: types.GET_MAP_OPTIONS,
      get_wind_uri: types.GET_WIND_URI,
      get_satellite_latest_time: types.GET_SATELLITE_LATEST_TIME
    }),

    ...mapActions({
      set_options: types.SET_OPTIONS,
      set_map_options: types.SET_MAP_OPTIONS,
      fetch_wind: types.FETCH_WIND_FILE,
      fetch_typhoon_probability: types.FETCH_TYPHOON_PROBABILITY
    }),

    init_time_lst_str (init_time_z_str) {
      return Date.createDateAsUTC(Date.dtgptime(init_time_z_str)).strftime('%Y/%m/%d %H:%M')
    },

    gen_selected_option (key, value) {
      return {
        [key]: value
      }
    },

    set_selected_option (key, value) {
      this.set_options({[key]: value})
      gtag('event', key, {"value": value})
    },

    set_selected_wind (value) {
      this.set_options({selected_wind_src: value})
    },

    set_selected_map_option (key, value) {
      this.set_map_options({ [key]: value })
    }
  },

  computed: {
    init_time_z_list () {
      // in descending order
      return this.get_init_time_z_list()
    },

    selected_init_time_z: {
      get () {
        return this.get_options().selected_init_time_z
      },
      set (value) {
        this.set_options({
          selected_init_time_z: value
        })
      }
    },

    selected_map_options () {
      return this.get_map_options()
    },

    selected_options () {
      return this.get_options()
    },

    selected_wind_src () {
      return this.get_options().selected_wind_src
    },

    selected_typhoon_probability () {
      return this.get_options().show_typhoon_probability
    },

    selected_probability_chart () {
      return this.get_options().show_probability_chart
    },

    satellite_latest_time() {
      return this.get_satellite_latest_time() ? this.get_satellite_latest_time().strftime('%H:%M') : ''
    },

    selected_wind_info() {
      let uri = this.get_wind_uri();
      if (uri) {
        try {
          var match = uri.match(/\w+_\d{12}/);
          let [src, dtg] = match[0].split("_");
          return Date.dtgptime(dtg).setTimezone(0).toLocal().strftime("%m/%d %H:%M");
        }
        catch (e) {}

        try {
          var match = uri.match(/\w+_\d{12}-\d{3}/);
          let strs = match[0].split("_");
          let src = strs[0];
          let [dtg, tau] = strs[1].split("-");
          return Date.dtgptime(dtg).setTimezone(0).toLocal().strftime("%m/%d %H:%M");
        }
        catch (e) {}
      }
    }
  },

  watch: {
    selected_wind_src (val, old) {
      if (val !== old) {
        this.fetch_wind();
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/typhoon_tw/Aside.vue